module.exports = __webpack_public_path__ + "img/MESSAGE.37b89167.svg";